import React from 'react';
import Accordion from 'components/Accordion';
import useGroup from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useGroup';
import useDeleteLocationGroup from 'hooks/Meteorology/Agro/useDeleteLocationGroup';
import Snackbar from 'components/DesignSystem/Snackbar';
import ConfirmationButton from 'components/ConfirmationButton';
import Searcher from 'components/DesignSystem/Searcher';
import useSearchFilter from 'hooks/useSearchFilter';
import RadioButton from 'components/DesignSystem/RadioButton';

export default function Group() {
  const { availableGroups, selectedGroup, setGroup } = useGroup();
  const { deleteGroup } = useDeleteLocationGroup();
  const groupsUnavailable = !availableGroups || availableGroups.length === 0;
  const { searchTerm, onSearchChange, searchIncludes } = useSearchFilter();
  const filteredGroups = availableGroups?.filter((group) => searchIncludes(group.name));

  return (
    <Accordion.Item eventKey="group" id="group-accordion">
      <Accordion.Header>Grupo</Accordion.Header>
      <Accordion.Body>
        {groupsUnavailable && (
          <Snackbar>
            Nenhum grupo disponível.
          </Snackbar>
        )}
        {!groupsUnavailable && (
          <>
            <Searcher
              value={searchTerm}
              onChange={onSearchChange}
              className="mb-2"
            />
            {filteredGroups?.map((group) => (
              <div
                id={`group-checkbox-${group.id}`}
                className="d-flex justify-content-between align-items-center"
                key={group.id}
              >
                <RadioButton
                  label={group.name}
                  checked={group.id === selectedGroup}
                  onChange={setGroup(group.id)}
                />
                <ConfirmationButton
                  id={`delete-group-${group.id}`}
                  type="tertiary"
                  onClick={() => deleteGroup(group.id)}
                  icon="trash"
                  confirmationBody={(
                    <p>
                      Tem certeza que deseja excluir o grupo
                      {' '}
                      <strong>{group.name}</strong>
                      ?
                    </p>
                  )}
                />
              </div>
            ))}
          </>
        )}
      </Accordion.Body>
    </Accordion.Item>
  );
}
